<div [ngClass]="hasContentFrame ? 'template-frame' : ''">
  <h1 class="template-titel template-font" *ngIf="!!titel">{{ titel }}</h1>
  <div
    class="template-content template-font"
    [ngClass]="isContentColorWhite ? 'template-content-white' : ''"
  >
    <ng-content></ng-content>
  </div>
</div>
